var dsox = dsox || {};
dsox.Slider = (function () {

    var heroSlider = function ($) {
        if($('.js-hero-slider').length) {
            //console.log('init js-hero-slider');
            $('.js-hero-slider')
            .slick({
                lazyLoad: "progressive",
                dots: true,
                dotsClass: "slick-dots hero-dots",
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                prevArrow: '<button type="button" class="slick-prev"><i aria-hidden="true" class="fas fa-chevron-left"></i>Previous</button>',
                nextArrow: '<button type="button" class="slick-next"><i aria-hidden="true" class="fas fa-chevron-right"></i>Next</button>'
            })
            .on('beforeChange', function(event, slick, currentSlide, nextSlide){
                //get the iframe inside this slide.
                var currentSlide = $(this).find(".slick-current");
                var player = currentSlide.find("iframe").get(0);
                var command = {
                    "event": "command",
                    "func": "pauseVideo"
                };
    
                //check if the player exists.
                if (player != undefined) {
                    //post our command to the iframe.
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }
            })
            .on('afterChange', function(event, slick, currentSlide, nextSlide){
                var currentSlide = $(this).find(".slick-current");
                //get the iframe inside this slide.
                var player = currentSlide.find("iframe").get(0);
                var command = {
                    "event": "command",
                    "func": "playVideo"
                };
    
                //check if the player exists.
                if (player != undefined) {
                    //post our command to the iframe.
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }
            })
        }

        if($('.js-hero-slider-ductsox').length) {
            //console.log('init js-hero-slider-ductsox');
            $('.js-hero-slider-ductsox')
            .slick({
                lazyLoad: "progressive",
                dots: true,
                dotsClass: "slick-dots hero-dots",
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                autoplay: true,
                autoplaySpeed: 5000,
                prevArrow: '<button type="button" class="slick-prev"><i aria-hidden="true" class="fas fa-chevron-left"></i>Previous</button>',
                nextArrow: '<button type="button" class="slick-next"><i aria-hidden="true" class="fas fa-chevron-right"></i>Next</button>'
            })
            .on('beforeChange', function(event, slick, currentSlide, nextSlide){
                //get the iframe inside this slide.
                var currentSlide = $(this).find(".slick-current");
                var player = currentSlide.find("iframe").get(0);
                var command = {
                    "event": "command",
                    "func": "pauseVideo"
                };
    
                //check if the player exists.
                if (player != undefined) {
                    //post our command to the iframe.
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }
            })
            .on('afterChange', function(event, slick, currentSlide, nextSlide){
                var currentSlide = $(this).find(".slick-current");
                //get the iframe inside this slide.
                var player = currentSlide.find("iframe").get(0);
                var command = {
                    "event": "command",
                    "func": "playVideo"
                };
    
                //check if the player exists.
                if (player != undefined) {
                    //post our command to the iframe.
                    player.contentWindow.postMessage(JSON.stringify(command), "*");
                }
            })

            $('.js-hero-slider-ductsox .slick-prev, .js-hero-slider-ductsox .slick-next').on('click', function(){
                $('.js-hero-slider-ductsox').slick('slickPause');//stop autoplay on click
            });
        }
        
    }

    var contentSlider = function ($) {
        var contentSlider = $('.js-content-slider');
        if(contentSlider.length) {
            contentSlider.each(function(){
                $(this)
                    .slick({
                        dots: true,
                        dotsClass: "slick-dots content-dots",
                        infinite: true,
                        lazyLoad: "progressive",
                        speed: 300,
                        slidesToShow: 1,
                        adaptiveHeight: false,
                        prevArrow: '<button type="button" class="slick-prev"><i aria-hidden="true" class="fas fa-chevron-left"></i>Previous</button>',
                        nextArrow: '<button type="button" class="slick-next"><i aria-hidden="true" class="fas fa-chevron-right"></i>Next</button>'
                    })
            })
        }
    }

    var cardSlider = function($) {
        var cardSlider = $('.js-card-slider');
        if(cardSlider.length){
            cardSlider.each(function(){
                //console.log('create cardSlider');
                $(this).slick({
                    dots:true,
                    dotsClass: "slick-dots content-dots",
                    speed: 300,
                    infinite: false,
                    slidesToShow: 1.5, //2.5,//2,
                    initialSlide: 0,
                    //centerMode: true,
                    //rows: 0,
                    //centerPadding: '120px',
                    prevArrow: '<button type="button" class="slick-prev"><i aria-hidden="true" class="fas fa-chevron-left"></i>Previous</button>',
                    nextArrow: '<button type="button" class="slick-next"><i aria-hidden="true" class="fas fa-chevron-right"></i>Next</button>',
                    responsive: [
                        // {
                        //     breakpoint: 1499,
                        //     settings: {
                        //         slidesToShow: 2.5,
                        //         // slidesToShow: 1,
                        //         // centerPadding: '70px'
                        //     }
                        // },
                        {
                            breakpoint: 1199,
                            settings: {
                                slidesToShow: 1.5,
                            }
                        },
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: 1.5,
                                // slidesToShow: 1,
                                // centerPadding: '15px',
                                // arrows: false
                            }
                        }
                    ]
                })

            })
        }
    }

    var photoSliderv1 = function($) {
        var photoSliderv1 = $('.js-photo-slider-v1');
        if(photoSliderv1.length){
            photoSliderv1.each(function(){
                $(this).slick({
                    dots: true,
                    dotsClass: "slick-dots content-dots",
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    prevArrow: '<button type="button" class="slick-prev"><i aria-hidden="true" class="fas fa-chevron-left"></i>Previous</button>',
                    nextArrow: '<button type="button" class="slick-next"><i aria-hidden="true" class="fas fa-chevron-right"></i>Next</button>'
                });

                $('body').on('click', '.js-slide-to', function () {
                    var slideIndex = $(this).data('index'),
                        $slickv1 = $(this).parent().parent().parent().find('.js-photo-slider-v1');
                    //console.log('$slickv1:', $slickv1.width());
                    $slickv1.slick('slickGoTo', slideIndex);
                });
            })
        }
    }

    var photoSliderv2 = function($) {
        var photoSliderv2 = $('.js-photo-slider-v2');
        if(photoSliderv2.length){
            photoSliderv2.each(function(){
                $(this).slick({
                    dots: true,
                    dotsClass: "slick-dots content-dots",
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    prevArrow: '<button type="button" class="slick-prev"><i aria-hidden="true" class="fas fa-chevron-left"></i>Previous</button>',
                    nextArrow: '<button type="button" class="slick-next"><i aria-hidden="true" class="fas fa-chevron-right"></i>Next</button>'
                });

                $that = $(this);
                $('body').on('click', '.js-slide-to', function () {
                    var slideIndex = $(this).data('index'),
                        $slickv2 = $(this).parent().parent().parent().find('.js-photo-slider-v2');
                    //console.log('.js-slide-to:', slideIndex);
                    $slickv2.slick('slickGoTo', slideIndex);
                });
            });
        }
    }

    var textSlider = function ($) {
        var textSlider = $('.js-text-slider');
        if(textSlider.length) {
            textSlider.each(function(){
                //console.log('load textSlider');
                $(this)
                    .slick({
                        dots: true,
                        dotsClass: "slick-dots content-dots",
                        infinite: true,
                        lazyLoad: "progressive",
                        speed: 300,
                        slidesToShow: 1,
                        adaptiveHeight: false,
                        prevArrow: '<button type="button" class="slick-prev"><i aria-hidden="true" class="fas fa-chevron-left"></i>Previous</button>',
                        nextArrow: '<button type="button" class="slick-next"><i aria-hidden="true" class="fas fa-chevron-right"></i>Next</button>'
                    })
            })
        }
    }

    return {
        heroSlider: heroSlider,
        contentSlider : contentSlider,
        cardSlider : cardSlider,
        photoSliderv1 : photoSliderv1,
        photoSliderv2 : photoSliderv2,
        textSlider : textSlider
    }
}());